import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  TContractsListResponse,
  TContractsListRequest,
  TRequestsForAnalysisCommunityResponse,
  TOpportunityAnalysisListData
} from './types'
import {
  TAvailableForEvaluationListRequest,
  TAvailableForEvaluationListResponse
} from '../CognusRepository/AvailableForEvaluation/types'
import {
  TOpportunityAnalysisContactPersonRequest,
  TOpportunityAnalysisContactPersonResponse,
  TOpportunityAnalysisListRequest,
  TOpportunityAnalysisListResponse,
  TRequestsForAnalysisCommonsResponse,
  TSavingAnalysisRequest
} from '../CognusRepository/OpportunityAnalysis/types'
import { ResponseWithPagination, VALIDATION_MESSAGES } from '../../constants'
import { TSavingResponse } from '../RequestForAnalysisDetails/types'
import {
  TContractPipelineList,
  TContractsPipelinesListRequest
} from '../ContractPipeline/Table/types'

const fetcher = new Fetcher({})

export const getContractsListCommonsAndCommunity = async (data) =>
  fetcher.request<TContractsListRequest, TContractsListResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.GROUPS}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getContractPipelineList = async (data) =>
  fetcher.request<
    TContractsPipelinesListRequest,
    ResponseWithPagination<TContractPipelineList>
  >({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.PIPELINES}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getAvailableForEvaluationList = async (data) =>
  fetcher.request<
    TAvailableForEvaluationListRequest,
    TAvailableForEvaluationListResponse
  >({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.AVALIABLE_OPPORTUNITIES}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getOpportunityAnalysisList = async (data) =>
  fetcher.request<
    TOpportunityAnalysisListRequest,
    TOpportunityAnalysisListResponse
  >({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.EVALUATION}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const getOpportunityAnalysisSavings = async (data) =>
  fetcher.request<TSavingAnalysisRequest, TSavingResponse>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.SAVINGS}`,
    method: HTTP_METHODS.GET,
    ...data
  })
export const setOpportunityAnalysisList = async (data) =>
  fetcher.request<unknown, TOpportunityAnalysisListData>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.EVALUATION}`,
    method: HTTP_METHODS.POST,
    successMessage: VALIDATION_MESSAGES.SM00131,
    data
  })
export const getLedByContactPersonsList = async (uuid) =>
  fetcher.request<
    TOpportunityAnalysisContactPersonRequest,
    TOpportunityAnalysisContactPersonResponse
  >({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.CONTRACT_GROUP}${uuid}/${API_DICTIONARY.CONTACT_PERSONS}`,
    method: HTTP_METHODS.GET
  })
export const getOpportunityAnalysisCommons = async () =>
  fetcher.request<unknown, TRequestsForAnalysisCommonsResponse>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.REQUESTS_FOR_ANALYSIS}`,
    method: HTTP_METHODS.GET
  })

export const getOpportunityAnalysisCommunity = async () =>
  fetcher.request<unknown, TRequestsForAnalysisCommunityResponse>({
    url: `${API_DICTIONARY.ANALYSIS}${API_DICTIONARY.REQUESTS_FOR_ANALYSIS}`,
    method: HTTP_METHODS.GET
  })
